import React from 'react';
import {withTranslation} from "react-i18next";
import ToOverviewComponent from "./ToOverviewComponent";

let GlobalErrorComponent = ({messageKey, t}) => {
    return <div id="global-error" className="row error-container">
            <div className="col-2"><span className="exclamation-sign"></span></div>
            <div className="col-10">
                <div id="global-error-details">
                    {messageKey ? t(messageKey) : t('error.global')}
                    <ToOverviewComponent/>
                </div>
            </div>
        </div>;



};

export default withTranslation() (GlobalErrorComponent)